export enum TitleAppearance {
    Filled = "full",
    Profile = "profile",
    Card = "card",
}
